module.exports = __webpack_public_path__ + "img/album18_46.5f39402b.jpg";